import PropChainTracker from "../../prop-tracker-utils/prop-chain-tracker.js";
import DictTrackerObjPtrGen from "../../prop-tracker-utils/dict-tracker-obj-ptr-gen.js";
import Combiner from "../../prop-tracker-utils/combiner.js";

import DeepValueMerger from "../../utils/deep-value-merger.js";

function isEmpty(obj) {
    for (const key in obj) {
        return false;
    }

    return true;
}

class DeepMerge {
    constructor(wrapCtx, evtCtx) {
        this._evtCtx = evtCtx;

        this._sources = {};

        this._merger = new Combiner((key) => new DeepValueMerger(wrapCtx, evtCtx));
        this._mergeGen = new DictTrackerObjPtrGen(wrapCtx, evtCtx, this._merger);
    }

    get merged() { return this._mergeGen.pointer; }

    track(priority, sourceData) {
        if (sourceData) {
            if (isEmpty(priority)) {
                this._mergeGen.start();
            }

            let source = this._sources[priority];

            if (!source) {
                source = new PropChainTracker(this._evtCtx);
                this._sources[priority] = source;
                this._merger.setSource(priority, source);
            }

            source.track(sourceData.data, ["value"]);
        } else {
            const source = this._sources[priority];
            source.track();

            this._merger.deleteSource(priority);
            delete this._sources[priority];

            if (isEmpty(priority)) {
                this._mergeGen.stop();
            }
        }
    }

    update() {
        this._mergeGen.update();
    }
}

export default DeepMerge;
